module.exports = __webpack_public_path__ + "static/media/gimnasio.caabbfa2.jpg";